export default __webpack_public_path__ + "static/media/Analysis.d24ea8fb.svg";